module.exports = __webpack_public_path__ + "img/fixation.e744f732.png";